<template>
	<div class="basic-container">
		<div>
			<div class="tool-box mobile-hide">
				<div class="search-bar">
					<input type="text" placeholder="검색" v-model="keywords" v-on:keyup.enter="searchKeyword" />
				</div>
			</div>
			<section class="table-area">
				<div class="table-header mobile-hide" ref="table">
					<div class="col-no">번호</div>
					<div>제목</div>
					<div class="col-icon">첨부파일</div>
					<div class="col-date">등록일</div>
					<div class="col-name">작성자</div>
				</div>
				<article class="table-list" v-for="(boardVO, i) in boardList" v-bind:key="type + i">
					<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
					<div class=" col-subject" :style="{ width: colAutoWidth > 0 ? colAutoWidth + 'px' : 'auto' }">
						<nav-link :url="'/board/' + type + '/' + boardVO.boardIdx">
							<img class="icon-pin" :src="require('../../assets/images/icon/icon-pin@2x.png')" v-if="boardVO.stateNotice === 'Y'" />
							{{ boardVO.contentTitle }}
							<span class="board-new" v-if="boardVO.newYn === 'Y'">NEW</span>
						</nav-link>
					</div>
					<div class="col-icon mobile-hide">
						<img class="icon-file" :src="require('../../assets/images/icon/icon-file@2x.png')" v-if="boardVO.boardFile != null" />
					</div>
					<div class="col-date">{{ $moment(boardVO.regDate).format('YY.MM.DD') }}</div>
					<div class="col-icon web-hide">
						<a class="icon-file-before" v-if="boardVO.boardFile != null"> | </a>
						<img class="icon-file" :src="require('../../assets/images/icon/icon-file-md@2x.png')" v-if="boardVO.boardFile != null" />
					</div>
					<div class="col-name mobile-hide">OKTA마케팅지원팀</div>
				</article>
			</section>
			<paging :total-count="totalCount" :page="listPage" :rows="listPageRow" :click="pageClick" />
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import Paging from '@/components/common/Paging';
import eventBus from '@/plugins/event-bus';

export default {
	components: { Paging },
	title: '게시판 목록',
	name: 'BoardList',
	props: ['type'],
	data: function() {
		return {
			loginMember: null,
			select: 1,
			isTableResize: false,
			colAutoWidth: 0,
			keywords: '',
			listPage: 1,
			listPageRow: 10,
			boardList: [],
			totalCount: 0,
		};
	},
	computed: {},
	watch: {
		type: function() {
			this.listPage = 1;
			this.$nextTick(this.getBoardList.bind(this));
		},
	},
	created() {
		eventBus.$on('LOAD_BOARD_DATA', v => {
			this.keywords = v;
			this.$nextTick(this.getBoardList.bind(this));
		});
	},
	mounted() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, this.type === 'notice' ? 'HOME_NOTICE' : 'HOME_PDS');
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		// window.onresize = this.onTableResize.bind(this);
		// this.onTableResize();
		this.$nextTick(this.getBoardList.bind(this));
	},
	beforeDestroy() {
		window.onresize = null;
	},
	methods: {
		// onTableResize: function() {
		// 	let totalWidth = this.$refs.table.offsetWidth;
		// 	let colWidth = 0;
		// 	for (let i in this.$refs.table.children) {
		// 		if (
		// 			this.$refs.table.children[i].className &&
		// 			this.$refs.table.children[i].className.indexOf('col-') > -1 &&
		// 			this.$refs.table.children[i].className.indexOf('col-auto') < 0
		// 		) {
		// 			colWidth += this.$refs.table.children[i].offsetWidth;
		// 		}
		// 	}
		// 	this.colAutoWidth = totalWidth - colWidth;
		// 	this.isTableResize = true;
		// 	this.$nextTick(() => {
		// 		this.isTableResize = false;
		// 	});
		// },
		searchKeyword: function() {
			this.listPage = 1;
			this.$nextTick(this.getBoardList.bind(this));
		},
		pageClick: function(p) {
			this.listPage = p;
			this.$nextTick(this.getBoardList.bind(this));
		},
		getBoardList: function() {
			this.boardList = [];
			let formData = new FormData();
			let boardTarget = this.loginMember.budsUserType;
			formData.append('boardTarget', boardTarget);
			formData.append('boardType', this.type);
			formData.append('keywords', this.keywords);
			formData.append('page', this.listPage);
			formData.append('row', this.listPageRow);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/board/getBoardList.do', formData)
				.then(res => {
					if (res.data.resultCode !== 0) {
						window.alert(res.data.resultMsg);
						this.$device.pushView('/board/notice');
					} else {
						this.boardList = res.data.data;
						this.totalCount = res.data.dataCount;
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
	},
};
</script>

<style scoped></style>
